import UserStats from '~/javascripts/components/CompletedProjectsMap/UserStats';
import { observer } from 'mobx-react';

const UserHeader = observer(
  ({ currentUser, projectCountryCount, userProjects }) => (
    <>
      <div className='theme-design-system-v1 map-header-container flex flex-col xl-flex-row justify-between'>
        <div className='flex flex-col xl-flex-row items-center justify-center p-8 text-center xl-text-left'>
          <div dangerouslySetInnerHTML={{ __html: currentUser.avatarHtml }} />
          <div className='flex flex-col pl-0 xl-pl-4'>
            <h1 className='heading-xl xl-heading-l text-cw-white pt-4 pb-2 xl-p-0 text-center xl-text-left'>
              {currentUser.displayName}
            </h1>
            <p className='body-xs text-cw-white'>
              Member since {currentUser.memberSince}
            </p>
          </div>
        </div>
        <UserStats
          currentUser={currentUser}
          projectCountryCount={projectCountryCount}
          userProjects={userProjects}
        />
      </div>
    </>
  )
);
export default UserHeader;
